<template>
  <div v-loading="loading">
    <el-row :gutter="3">
      <el-col :span="24" v-for="item in tableData" :key="item.id">
        <h5>{{ item.typeName }}</h5>
        <el-image
          style="height: 160px"
          :src="item.thumbUrl"
          fit="fill"
          @click="onClick(item)"
        >
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div></el-image
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { itemData } from '@/api/tdcs/attach.js';

export default {
  data() {
    return {
      loading: true,
      tableData: []
    };
  },
  methods: {
    show(mavinEid) {
      this.loading = true;
      itemData(mavinEid).then(res => {
        this.tableData = res;
        this.loading = false;
      });
    },
    onClick(item) {
      window.open(item.attachUrl);
    }
  },
  created() {
    this.show(this.$route.params.mavinEid);
  }
};
</script>

<style>
.el-image {
  cursor: pointer;
}
</style>
